import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 5 * 60 * 60 * 1000, // 5 hours
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default queryClient;